import { render, staticRenderFns } from "./incorrectDemonstration.vue?vue&type=template&id=1c329ec4&scoped=true&"
import script from "./incorrectDemonstration.vue?vue&type=script&lang=js&"
export * from "./incorrectDemonstration.vue?vue&type=script&lang=js&"
import style0 from "./incorrectDemonstration.vue?vue&type=style&index=0&id=1c329ec4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c329ec4",
  null
  
)

export default component.exports